export const AssignFormStore = {
    selectedDivisions: [],
    divisionWithChild: false,
    selectedCourse: 0,
};